<!-- eslint-disable -->
<template>
  <div id="notfound">
    <div class="notfound context">
      <div class="notfound-404">
        <img :src="image" class="notfound-404" />
      </div>
      <div>
        <template v-if="$store.getters.permissionInfo.enable_sponsor && error_sponsor_icon !== undefined">
          <img v-for="(item, key) in error_sponsor_icon" :key="key" class="mw-100 mx-2" :src="item.image" width="24">
        </template>
      </div>
      <p>
        <span class="nl2br">
          {{ message }}
        </span>
        <br> <br>
        <a v-if="csUrl" class="mr-3" target="_blank" :href="csUrl"> {{ $t('Bao.contanct_service') }} </a>
        <a href="/">{{ returnLabel }} </a>
      </p>
    </div>
  </div>
</template>

<script>
import '@/assets/error.css'
import { getImage } from '@/api/brand'

export default {
  name: 'Error',
  data() {
    return {
      message: this.$te('Bao.sorry_for_the_error') ? this.$t('Bao.sorry_for_the_error') : 'Error',
      returnLabel: 'Return',
      csUrl: false,
      image: this.$store.getters.brand.image !== undefined ? this.$store.getters.brand.image : '',
      error_sponsor_icon: null
    }
  },
  created() {
    if (this.$store.state.brand.urlInfo.csUrl !== null) {
      this.csUrl = this.$store.state.brand.urlInfo.csUrl
    } else {
      this.csUrl = 'https://kiifssbyt.chatnow.mstatik.com/widget/standalone.html?eid=1515bdfbfd2280309775d317c9901c9e'
    }
    this.message = this.$store.getters.errorMessage ? this.$store.getters.errorMessage : this.$t('Bao.sorry_for_the_error')
    this.$store.commit('SET_ERROR_MESSAGE', null)

    getImage({
      'group_code': 'error_sponsor_icon'
    }).then(response => {
      this.error_sponsor_icon = response.data.data
    }).catch((error) => {
      console.log(error)
    })
  },
  mounted() {
    document.body.classList.add('error_body')

    this.returnLabel = this.$te('Bao.return_back') ? this.$t('Bao.return_back') : 'Return'
  },
  destroyed() {
    document.body.classList.remove('error_body')
  }
}
</script>

<style scoped>
* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.context {
  display: flex;
  flex-direction: column;
}

</style>
